import { Routes } from '@angular/router';

// Sustituye a dev-routes.ts en el build de producción (ver fileReplacements en angular.json).
export const devRoutes: Routes = [];
